import React from 'react';
import ReactMarkdown from 'react-markdown';
import PanelWrapper from '../PanelWrapper';

const MarkdownPanelContent = ({ panelData }) => {
    const sections = Array.isArray(panelData?.data) ? panelData.data
                   : Array.isArray(panelData) ? panelData
                   : [];

    return (
        <div className="markdown-panel">
            {sections.map((section) => (
                <div key={section.id} className="markdown-panel__section">
                    <ReactMarkdown>{section.content}</ReactMarkdown>
                </div>
            ))}
        </div>
    );
};

const MarkdownPanel = ({ chart }) => {
    return (
        <PanelWrapper panel={chart} showDescription={true} showNoDataPanel={false}>
            {(panelData) => <MarkdownPanelContent panelData={panelData} />}
        </PanelWrapper>
    );
};

export default React.memo(MarkdownPanel);
